import React, { useState } from "react";
import "./scss/floating-textarea.scss";

export default function FloatingTextarea({
  label,
  className = "",
  value,
  onChange,
  rows = 4,
  ...props
}) {
  const [focused, setFocused] = useState(false);

  const isActive = focused || (value && value.toString().length > 0);

  return (
    <div className={`floating-textarea ${isActive ? "active" : ""} ${className}`}>
      <textarea
        {...props}
        rows={rows}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <label>{label}</label>
    </div>
  );
}
